import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import queryKeys from '~/features/admin/components/agent/utils'
import { queryKeysUsers } from '~/features/admin/components/home/utils'
import { EUserStatus, TUser } from '~/features/user/models'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

type TParams = {
  id: string
  lastLogin?: string
  adminOwned?: boolean
  name?: string
  status?: EUserStatus
}

type TUpdateUser = {
  params: TParams
  orgId?: string
  showToast?: boolean
}

const useUpdateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TUpdateUser) =>
      HttpService.put<TUser>({
        path: EServerPath.users,
        payload: payload.params,
      }),
    onSuccess(response, variables) {
      const orgId = response?.data?.orgId || variables?.orgId
      const userId = response?.data?.id || variables?.params?.id

      if (orgId) {
        queryClient.setQueryData(
          queryKeys.user(orgId),
          response?.data || undefined,
        )

        queryClient.invalidateQueries({
          queryKey: queryKeys.user(orgId),
        })
      }

      queryClient.setQueryData(
        queryKeysUsers.user(userId),
        response?.data || undefined,
      )

      queryClient.invalidateQueries({
        queryKey: queryKeysUsers.user(userId),
      })
    },
    onError: (_, variables) => {
      const showToast = variables?.showToast
      if (showToast) {
        toast.dismiss()
        toast.error("Couldn't update user, please try again later.")
      }
    },
  })
}

export default useUpdateUser
